import type { EditSection } from './MyNazcaImageEditorPreview';
import { MyNazcaImageEditorControls, type MyNazcaImageEditorControlsProps } from './MyNazcaImageEditorControls';

const EDIT_SECTIONS: { id: EditSection; labelJa: string; labelEn: string }[] = [
  { id: 'crop', labelJa: 'トリミング', labelEn: 'Crop' },
  { id: 'background', labelJa: '背景', labelEn: 'Background' },
  { id: 'tone', labelJa: 'トーン', labelEn: 'Tone' },
];

type MyNazcaImageEditorFieldsProps = {
  lang: 'ja' | 'en';
  busy: string | null;
  activeSection: EditSection;
  canUndo: boolean;
  canRedo: boolean;
  onSelectSection: (section: EditSection) => void;
  onUndo: () => void;
  onRedo: () => void;
  controlsProps: Omit<MyNazcaImageEditorControlsProps, 'section' | 'variant' | 'lang' | 'busy'>;
};

export function MyNazcaImageEditorFields({
  lang,
  busy,
  activeSection,
  canUndo,
  canRedo,
  onSelectSection,
  onUndo,
  onRedo,
  controlsProps,
}: MyNazcaImageEditorFieldsProps) {
  return (
    <div className="mynazca-app__route-mode-shell mynazca-app__image-edit-shell">
      <div className="mynazca-app__image-edit-history" role="toolbar" aria-label={lang === 'ja' ? '編集履歴' : 'Edit history'}>
        <button
          type="button"
          className="mynazca-app__image-edit-history-btn"
          onClick={() => onUndo()}
          disabled={!canUndo || busy != null}
        >
          Undo
        </button>
        <button
          type="button"
          className="mynazca-app__image-edit-history-btn"
          onClick={() => onRedo()}
          disabled={!canRedo || busy != null}
        >
          Redo
        </button>
      </div>

      <div
        className="mynazca-app__route-mode-tabs"
        role="tablist"
        aria-label={lang === 'ja' ? '画像編集' : 'Image editing'}
      >
        {EDIT_SECTIONS.map(({ id, labelJa, labelEn }) => (
          <button
            key={id}
            type="button"
            role="tab"
            id={`mynazca-edit-tab-${id}`}
            aria-selected={activeSection === id}
            aria-controls={`mynazca-edit-panel-${id}`}
            className={`mynazca-app__route-mode-tab${activeSection === id ? ' mynazca-app__route-mode-tab--active' : ''}`}
            onClick={() => onSelectSection(id)}
            disabled={busy != null}
          >
            {lang === 'ja' ? labelJa : labelEn}
          </button>
        ))}
      </div>

      <div
        id={`mynazca-edit-panel-${activeSection}`}
        role="tabpanel"
        aria-labelledby={`mynazca-edit-tab-${activeSection}`}
        className="mynazca-app__route-mode-panel"
      >
        <MyNazcaImageEditorControls
          section={activeSection}
          variant="tab-panel"
          lang={lang}
          busy={busy}
          {...controlsProps}
        />
      </div>
    </div>
  );
}
